/* unplugin-vue-components disabled */import { render } from "./Head.vue?vue&type=template&id=23edb38c&scoped=true"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"

import "./Head.vue?vue&type=style&index=0&id=23edb38c&lang=scss&scoped=true"
import "./Head.vue?vue&type=style&index=1&id=23edb38c&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈工程-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23edb38c"]])

export default __exports__